var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSimpleIconsGooglesheets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5308 12.4088H9.18785V10.977H11.5322V12.4095L11.5308 12.4088ZM13.8751 3V7.5H18L13.8751 3ZM14.8121 10.977H12.4678V12.4095H14.8121V10.977ZM14.8121 13.4318H12.4678V14.8643H14.8121V13.4318ZM17.9993 7.875V19.773C17.9993 20.451 17.4961 21 16.8746 21H7.12472C6.97702 21 6.83077 20.9683 6.69431 20.9066C6.55785 20.8449 6.43386 20.7546 6.32942 20.6406C6.1185 20.4105 6 20.0984 6 19.773V4.227C6 3.549 6.50324 3 7.12472 3H13.5307V7.875H17.9993ZM15.7492 9.95475H8.24944V15.8865H15.7499V9.954L15.7492 9.95475ZM11.5308 13.4318H9.18785V14.8643H11.5322V13.4318H11.5308Z",
    fill: "#4F9D50"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 15.2,
    width: 7.6,
    height: 7.6,
    rx: 0.6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15.2,
    y: 15.2,
    width: 7.6,
    height: 7.6,
    rx: 0.6,
    stroke: "#E9ECF2",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5535 20.3291C16.719 20.3136 16.8489 20.3063 16.9451 20.3063C17.0414 20.3063 17.1661 20.3129 17.3208 20.327C17.2558 20.475 17.1995 20.5905 17.1516 20.6756L17.1516 20.6756C17.1036 20.7608 17.0324 20.8713 16.9361 21.0082L16.8022 20.7709L16.802 20.7705L16.5535 20.3291Z",
    fill: "#0066DA",
    stroke: "#31A8DF",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.051 21.6687C21.1438 21.6123 21.2228 21.5347 21.2778 21.436L21.3878 21.2421L21.9136 20.3078C21.9676 20.2112 21.996 20.1018 21.9961 19.9905C21.5692 19.9343 21.2548 19.9062 21.0527 19.9062C20.8355 19.9062 20.5211 19.9343 20.1094 19.9905C20.2618 20.3924 20.3901 20.6862 20.4943 20.8719C20.5994 21.0592 20.7849 21.3248 21.051 21.6687Z",
    fill: "#EA4335"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 18.0129C19.3073 17.6319 19.5192 17.338 19.6355 17.1315C19.7292 16.9651 19.8323 16.6995 19.9448 16.3346C19.852 16.2782 19.7455 16.25 19.6355 16.25H18.364C18.254 16.25 18.1475 16.2817 18.0547 16.3346C18.1978 16.7531 18.3193 17.0509 18.419 17.228C18.5293 17.4238 18.7229 17.6854 18.9998 18.0129Z",
    fill: "#00832D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1104 19.9844H17.8904L16.9453 21.6626C17.0381 21.719 17.1446 21.7473 17.2546 21.7473H20.7462C20.8562 21.7473 20.9627 21.7155 21.0555 21.6626L20.1104 19.9844Z",
    fill: "#2684FC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 18.0064L18.0551 16.3281C17.9623 16.3845 17.8833 16.4621 17.8283 16.5608L16.0825 19.6635C16.0285 19.7601 16.0001 19.8695 16 19.9808H17.8901L19.0002 18.0064Z",
    fill: "#00AC47"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0448 18.1122L20.1719 16.5608C20.1169 16.4621 20.0378 16.3845 19.945 16.3281L19 18.0064L20.11 19.9808H21.9967C21.9967 19.8715 21.9692 19.7622 21.9142 19.6635L21.0448 18.1122Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleIconsGooglesheets);
export default __webpack_public_path__ + "static/media/simple-icons_googlesheets.e88ee0ce90b3a0d08df563faf034e9d3.svg";
export { ForwardRef as ReactComponent };